module.exports = __webpack_public_path__ + "static/media/twitter-pink-on-blue.a890bef4.svg";